import React from "react";
import "./style.css";

class Footer extends React.Component {
  render() {
    return (
      <div className="adminFooter animate__animated animate__fadeInUp tc">
        <span>Copyright {"\u00A9"} WORK 2021 | All Rights Reserved</span>
      </div>
    );
  }
}

export default Footer;
